import { rSimProductsQueries } from 'rSimInventory/utils/rsimProductsQueries.ts';
import { useValidatedSearchId } from 'common/components/Filters/hooks/useValidatedSearchId.ts';
import { useAtomValue } from 'jotai';
import {
  pageFilterAtom,
  rowsPerPageFilterAtom,
  rsimFiltersAtom,
  rsimSortingAtomWithStorage,
} from 'atoms/filters/rsim-products.ts';

export const useRSimQueryKey = () => {
  const rowsPerPage = useAtomValue(rowsPerPageFilterAtom);
  const page = useAtomValue(pageFilterAtom);
  const sorting = useAtomValue(rsimSortingAtomWithStorage);
  const filters = useAtomValue(rsimFiltersAtom);
  const {
    searchText,
    chosenIdType,
    lastActiveProfile,
    lastUpdateTime,
    tags,
    connectionId,
    orderNumber,
    simulateOutage,
    accounts,
    productCodes,
    eidFrom,
    eidTo,
    subscriptionStatus,
    mobileNetworkOperator,
    mobileNetworkOperatorId,
    mnoNames,
  } = filters;
  const { search } = useValidatedSearchId(searchText);
  return rSimProductsQueries.list({
    sorting,
    page,
    rowsPerPage,
    accounts,
    productCodes,
    chosenIdType,
    connectionId,
    lastActiveProfile,
    orderNumber,
    searchText: search,
    simulateOutage,
    tags,
    eidFrom,
    eidTo,
    lastUpdateTime,
    subscriptionStatus,
    mobileNetworkOperator,
    mnoNames,
    mobileNetworkOperatorId,
  });
};
